// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aMnc","col":"styles_col__1yaue"};